import QxQPublicPage from '../views/QxQPublicPage/QxQPublicPage';
import QxQFacilityShowPage from '../views/QxQFacilityShowPage/QxQFacilityShowPage';

var indexRoutes = [
  {path: '/facilities/:facilityId', name: 'QxQFacilityShowPage', component: QxQFacilityShowPage},
  {path: '/', name: 'QxQPublicPage', component: QxQPublicPage}
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx